// src/pages/landing/components/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import treadmill from '../../../assets/images/treadmill-v1.png';

const Header = () => {
  const navigate = useNavigate();

  const handleStartJourney = () => {
    navigate('/exercise');
  };

  const handleExploreMap = () => {
    const el = document.getElementById('about');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header className="header">
      <div className="hero-section">

        {/* ── Left: Content ── */}
        <div className="hero-content">

          {/* Eyebrow badge */}
          <span className="hero-badge">Welcome to UBC Wellness</span>

          {/* Headline */}
          <h1 className="hero-title">
            Move with<br />
            <span className="highlight">your</span> Mood.
          </h1>

          {/* Sub-copy */}
          <p className="hero-subtitle">
            made for student life, MOOD2MOVE is here to help you find a
            better way to move and fits how you feel
          </p>

          {/* CTAs */}
          <div className="cta-section">
            <button className="cta-primary" onClick={handleStartJourney}>
              Discover Your Mood
              <span className="cta-arrow">→</span>
            </button>
            <button className="cta-secondary" onClick={handleExploreMap}>
              Learn More
            </button>
          </div>
        </div>

        {/* ── Right: Illustration ── */}
        <div className="hero-image">
          <img
            src={treadmill}
            alt="Personalized Fitness"
            className="treadmill-image"
          />
          <div className="floating-icon icon-1">💪</div>
          <div className="floating-icon icon-2">🧠</div>
          <div className="floating-icon icon-3">❤️</div>
        </div>

      </div>
    </header>
  );
};

export default Header;